module.exports = __webpack_public_path__ + "e16259b75c209b62c5124d924e12897c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/paymentSelected.png
// module id = 319
// module chunks = 0